module.exports = __webpack_public_path__ + "assets/icons/guaranteed-safe-updated.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/guaranteed-safe-updated.png
// module id = ./src/styles/icons/guaranteed-safe-updated.png
// module chunks = 0